module.exports = __webpack_public_path__ + "static/media/flipflop-transparent.fffc8bc7.png";